import { render, staticRenderFns } from "./alerta.vue?vue&type=template&id=ec33d0d0&scoped=true&"
import script from "./alerta.component.ts?vue&type=script&lang=ts&"
export * from "./alerta.component.ts?vue&type=script&lang=ts&"
import style0 from "./alerta.vue?vue&type=style&index=0&id=ec33d0d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec33d0d0",
  null
  
)

export default component.exports